/**
 * Redirige el navegador a la URL indicada cuando el servidor lo solicita
 * a través del atributo `redirect_url` (p.ej. al terminar de firmar).
 *
 * Sólo se aceptan URLs absolutas http/https o rutas relativas que comiencen
 * con "/", evitando redirigir a valores inválidos o esquemas potencialmente
 * inseguros (javascript:, data:, etc.).
 *
 * El delay por defecto es 0 (redirección inmediata). Los componentes que
 * quieran mostrar un mensaje de éxito antes deben pasar el delay explícito
 * o, mejor todavía, gestionar el countdown ellos mismos y llamar a esta
 * función con delay=0 sólo cuando termine la espera visible.
 *
 * @param {string} url - URL a la que redirigir.
 * @param {number} [delay=0] - Milisegundos a esperar antes de redirigir.
 * @returns {boolean} `true` si se programó la redirección, `false` en caso contrario.
 */
export function redirectToUrl(url, delay = 0) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return false;
  }

  const isAbsolute = /^https?:\/\//i.test(trimmed);
  if (!isAbsolute && !trimmed.startsWith('/')) {
    return false;
  }

  if (delay && Number.isFinite(delay) && delay > 0) {
    setTimeout(() => {
      window.location.href = trimmed;
    }, delay);
  } else {
    window.location.href = trimmed;
  }
  return true;
}